<template>
  <modal name="share_social_post_modal" @before-open="beforeOpen" height="auto">
    <div class="modal_container modal_container--social_post share-modal" v-if="socialPost">
      <div class="modal_header mb-0">
        <h2>Share Social Post</h2>
        <div class="closer" @click="$modal.hide('share_social_post_modal')">
          <TimesIcon />
        </div>
      </div>
      <div class="modal_body">
        Click to copy the link to this social post
        <b-input-group class="mt-2">
          <b-form-input v-model="assetListShareUrl"></b-form-input>
          <template #append>
            <b-button @click="copyUrl">
              <BIconStickies></BIconStickies>
            </b-button>
          </template>
        </b-input-group>

        <div class="d-flex justify-content-end">
          <b-button variant="primary" class="mt-3" @click="openOriginalPost">
            <b-icon icon="box-arrow-up-right" />
            View Original Post
          </b-button>
        </div>
      </div>
    </div>
  </modal>
</template>
<script lang="ts">
import TimesIcon from './graphics/TimesIcon.vue'
import { copyToClipboard } from '@lib/copyToClipboard'
import { generateShareLink } from '@lib/share_link'

export default {
  components: { TimesIcon },
  data() {
    return {
      socialPost: null,
    }
  },
  computed: {
    assetListShareUrl() {
      return generateShareLink(this.socialPost.identifier)
    },
  },
  methods: {
    openOriginalPost() {
      window.open(this.socialPost.url, '_blank')
    },
    beforeOpen(e) {
      this.socialPost = e.params.socialPost
    },
    copyUrl() {
      copyToClipboard(generateShareLink(this.socialPost.identifier))
      this.$toast('Social Post URL copied to clipboard')
    },
  },
}
</script>
